<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-18T14:07:39+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-06-09T16:45:12+02:00
@Copyright: Diversitude 2022
-->

<template>
    <b-card>
        <b-row>
            <b-col cols="12" v-if="is_loading == false && selected_level_id != null">
                <span class="d-flex">
                    <span class="d-inline-flex">
                        <h4 class="p-0 m-0 pt-2">{{cardName}}</h4>
                    </span>
                    
                    <b-button v-if="selected_level_id != null" variant="info" class="ms-auto mb-1 me-1" style="" @click="clearSelectedLevel">Show All Users</b-button>
                    <b-button variant="success" class=" mb-1" style="" @click="showUserModal('new')">Add User</b-button>
                </span>
                
            </b-col>
            <b-col cols="12">
                <webix-ui v-if="is_loading == false && hasUsers" :config="ui" v-model="users"></webix-ui>
                <b-alert variant="warning" :show="!is_loading && !hasUsers">
                    No users for this level
                </b-alert>
                <b-overlay :show="is_loading" no-wrap></b-overlay>
            </b-col>
        </b-row>
        <UserModal
        v-if="show_modal"
        :user_data="selected_user_object"
        :selected_level_id="selected_level_id"
        @selectNewUser="refreshNewUser"/>
    </b-card>
</template>

<script>
import Swal from 'sweetalert2'
import _ from 'lodash'
import UserModal from '../components/userModal.vue'
import { clientAdminState, clientAdminMethods } from '@/state/helpers'
export default {
    props:{
        selected_level_id:{},
    },
    components:{
        UserModal
    },
    data:() => ({
        lead_user_id: null,
        selected_user_object:null,
        show_modal: false,
        is_loading: true,
        ui:{
            id: 'clientUsersTable',
            view:'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            columns:[],
            on: {

            },
            onClick:{
                //eslint-disable-next-line
                set_lead_user:function(id, e, trg) {
                    let el = this.$scope.$parent;
                    el.setLeadUser(e.row)
                },
                //eslint-disable-next-line
                delete_user: function (id, e, trg) {
                    var el = this.$scope.$parent;
                    var item = this.getItem(e.row);
                    Swal.fire({
                        title: "Are you sure you want to delete " + item.name + "?",
                        text: "You won't be able to revert this!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#34c38f",
                        cancelButtonColor: "#f46a6a",
                        confirmButtonText: "Yes"
                    }).then(result => {
                        if (result.value) {
                            el.deleteUser({user_id: e.row}).then(()=>{
                                el.initTable();
                            });
                        }
                    });
                },
                //eslint-disable-next-line
                view_user:function(a, data){
                    var item = this.getItem(data.row)
                        let el = this.$scope.$parent;
                        if(el.selected_level_id == null){
                            let index = _.findIndex(el.all_users, {id: item.id});
                            if(index > -1){
                                el.selected_user_object = {
                                    id: el.all_users[index].id,
                                    level_id: el.all_users[index].level_id,
                                    name: el.all_users[index].name,
                                    cell_no: el.all_users[index].cell_no,
                                    email: el.all_users[index].email,
                                    designation: el.all_users[index].designation,
                                    id_number: el.all_users[index].id_number,
                                    academic_qualifications: el.all_users[index].academic_qualifications,
                                    work_qualifications: el.all_users[index].work_qualifications,
                                    years_experience: el.all_users[index].years_experience,
                                    id_copy_s3_src: el.all_users[index].id_copy_s3_src,
                                    job_desc_s3_src: el.all_users[index].job_desc_s3_src,
                                    letter_of_acceptance_s3_src: el.all_users[index].letter_of_acceptance_s3_src,
                                    letter_of_appointment_s3_src: el.all_users[index].letter_of_appointment_s3_src,
                                    police_clearance_s3_src: el.all_users[index].police_clearance_s3_src,
                                }
                                console.log( el.selected_user_object);
                                el.showUserModal('existing', el.selected_user_object);
                            }
                        }
                        else{
                            let index = _.findIndex(el.users_in_level, {id: item.id});
                            if(index > -1){
                                el.selected_user_object = {
                                    id: el.users_in_level[index].id,
                                    level_id: el.users_in_level[index].level_id,
                                    name: el.users_in_level[index].name,
                                    cell_no: el.users_in_level[index].cell_no,
                                    email: el.users_in_level[index].email,
                                    designation: el.users_in_level[index].designation,
                                    id_number: el.users_in_level[index].id_number,
                                    academic_qualifications: el.users_in_level[index].academic_qualifications,
                                    work_qualifications: el.users_in_level[index].work_qualifications,
                                    years_experience: el.users_in_level[index].years_experience,
                                    id_copy_s3_src: el.users_in_level[index].id_copy_s3_src,
                                    job_desc_s3_src: el.users_in_level[index].job_desc_s3_src,
                                    letter_of_acceptance_s3_src: el.users_in_level[index].letter_of_acceptance_s3_src,
                                    letter_of_appointment_s3_src: el.users_in_level[index].letter_of_appointment_s3_src,
                                    police_clearance_s3_src: el.users_in_level[index].police_clearance_s3_src,
                                }
                                console.log( el.selected_user_object);
                                el.showUserModal('existing', el.selected_user_object);
                            }
                        }
                }
            },
        },
    }),
    computed:{
        ...clientAdminState,
        hasUsers(){
            if(this.users.length){
                return true;
            }
            else{
                return false;
            }
        },
        users(){
            if(this.selected_level_id == null){
                return this.all_client_users;
            }
            else{
                return this.client_users;
            }
        },
        client_users(){
            if(this.users_in_level == null){
                return [];
            }
            else{
                let level_name = '';
                this.user_levels.forEach( itm => {
                    if(itm.id == this.selected_level_id){
                        level_name = itm.name;
                    }
                })

                let data = [];
                this.users_in_level.forEach( item => {
                    //* check for missing document uploads
                    let has_all_documents_uploaded = true;
                    if( item.police_clearance_s3_src == null ||
                        item.id_copy_s3_src == null ||
                        item.job_desc_s3_src == null ||
                        item.letter_of_acceptance_s3_src == null ||
                        item.letter_of_appointment_s3_src == null){
                        //* used as a flag for the webix table
                        has_all_documents_uploaded = false;
                    }
                    data.push({
                        name: item.name,
                        level_name: level_name,
                        id: item.id,
                        lead_user: this.lead_user_id == item.id,
                        has_all_documents_uploaded: has_all_documents_uploaded,
                    })
                });
                return data;
            }
        },
        all_client_users(){
            if(this.all_users == null){
                return [];
            }
            else{
                //* process the data to show all assigned levels, and flag users with missing document uploads
                let data = [];
                let d = _.cloneDeep(this.all_users)
                d.forEach( item => {
                    let has_all_documents_uploaded = true;
                    let level_name = 'Not added to level';
                    // add all assigned level names
                    if(item.levels.length > 0){
                        level_name = '';
                        item.levels.forEach( level =>{
                            if(level_name === ''){
                                level_name += level.name;
                            }
                            else{
                                level_name += ', '+level.name;
                            }
                        })
                    }
                    if( item.police_clearance_s3_src == null ||
                        item.id_copy_s3_src == null ||
                        item.job_desc_s3_src == null ||
                        item.letter_of_acceptance_s3_src == null ||
                        item.letter_of_appointment_s3_src == null){
                        //* used as a flag for the webix table
                        has_all_documents_uploaded = false;
                    }
                    //check for mssing documents
                    data.push({
                        name: item.name,
                        level_name: level_name,
                        id: item.id,
                        lead_user: this.lead_user_id == item.id,
                        has_all_documents_uploaded: has_all_documents_uploaded,
                    })
                });
                return data;
            }
        },

        cardName(){
            if(this.selected_level_id == null){
                return 'All users'
            }
            else{
                let level_name = '';
                this.user_levels.forEach( itm => {
                    if(itm.id == this.selected_level_id){
                        level_name = itm.name;
                    }
                })
                return level_name;
            }
        },
        all_users_columns(){
            let cols = [
                { id:"id", header:"", hidden: true, fillspace: 0},
                { id:"name", header:['Client Name', {content:"textFilter", placeholder:"Type here to search User / Level", colspan:3}], fillspace: true,
                    template:function(object){
                        if(object.has_all_documents_uploaded){
                            return object.name;
                        }
                        else{
                            return `<span class="text-danger">${object.name}</span>`
                        }
                    }
                },
                { id:"level_name", header:"Level Name", fillspace:1},
                { id: "actions", header: "Actions", fillspace: 0.5,
                    template(){
                        return `
                        <div class="d-flex" style="justify-content: space-evenly;">
                            <span class="view_user text-selectable text-primary">View</span>
                            <span class="delete_user text-selectable text-danger">Delete</span>
                        </div>
                        `
                    }
                },
            ];
            return cols;
        },
        level_users_columns(){
            let cols = [
                { id:"id", header:"", hidden: true, fillspace: 0},
                { id:"name", header:['Client Name', {content:"textFilter", placeholder:"Type here to search User / Level", colspan:4}], fillspace: true,
                    template:function(object){
                        if(object.has_all_documents_uploaded){
                            return object.name;
                        }
                        else{
                            return `<span class="text-danger">${object.name}</span>`
                        }
                    }
                },
                { id:"level_name", header:"Level Name", fillspace:1},
                { id: "actions", header: "Actions", fillspace: 0.5,
                    template(){
                        return `
                        <div class="d-flex" style="justify-content: space-evenly;">
                            <span class="view_user text-selectable text-primary">View</span>
                            <span class="delete_user text-selectable text-danger">Delete</span>
                        </div>
                        `
                    }
                },
                { id: 'lead_user', header: 'Lead User', width: '150',
                    template(obj){
                        if(obj.lead_user == true){
                            return `
                            <div class="d-flex" style="justify-content: space-evenly;">
                            <span class="text-success">Lead User</span>
                            </div>
                            `
                        }
                        else{
                            return `
                            <div class="d-flex" style="justify-content: space-evenly;">
                            <span class="set_lead_user text-selectable text-primary">Set as Lead User</span>
                            </div>
                            `
                        }
                    }
                }
            ];
            return cols;
        },
    },
    methods:{
        ...clientAdminMethods,
        showUserModal(type, user = null){//new - existing
            this.selected_user_object = user;
            if(type === 'new'){
                this.show_modal = true;
                this.$nextTick(()=>{
                    this.$bvModal.show('manageUsersModal');
                    this.$root.$once('bv::modal::hidden',(event)=>{
                        if(event.type == 'hidden' && event.componentId == 'manageUsersModal'){
                            this.show_modal = false;
                        }
                    })

                })
            }
            else{
                this.show_modal = true;
                this.$nextTick(()=>{
                    this.$bvModal.show('manageUsersModal');
                    this.$root.$once('bv::modal::hidden',(event)=>{
                        if(event.type == 'hidden' && event.componentId == 'manageUsersModal'){
                            this.show_modal = false;
                        }
                    })
                })
            }
        },
        setLeadUserID(){
            if(this.selected_level_id != null){
                let el = this;
                let index = _.findIndex(this.user_levels, function(o){
                    return o.id == el.selected_level_id;
                });
                if(index != -1){
                    //if isArray == true then there are no lead users. the lead_user var is an object if valid
                    if(Array.isArray(this.user_levels[index].lead_user) == false){
                        this.lead_user_id = this.user_levels[index].lead_user.id;
                    }
                }
            }
        },
        refreshNewUser(id){
            let index = _.findIndex(this.users_in_level, function(o){
                return Number(o.id) == Number(id);
            });
            if(index > -1){
                this.selected_user_object = {
                    id: this.users_in_level[index].id,
                    level_id: this.users_in_level[index].level_id,
                    name: this.users_in_level[index].name,
                    cell_no: this.users_in_level[index].cell_no,
                    email: this.users_in_level[index].email,
                    designation: this.users_in_level[index].designation,
                    id_number: this.users_in_level[index].id_number,
                    academic_qualifications: this.users_in_level[index].academic_qualifications,
                    work_qualifications: this.users_in_level[index].work_qualifications,
                    years_experience: this.users_in_level[index].years_experience,
                    id_copy_s3_src: this.users_in_level[index].id_copy_s3_src,
                    job_desc_s3_src: this.users_in_level[index].job_desc_s3_src,
                    letter_of_acceptance_s3_src: this.users_in_level[index].letter_of_acceptance_s3_src,
                    letter_of_appointment_s3_src: this.users_in_level[index].letter_of_appointment_s3_src,
                    police_clearance_s3_src: this.users_in_level[index].police_clearance_s3_src,
                }
            }
        },
        setLeadUser(id){
            if(this.selected_level_id != null){
                let params = {
                    user_id: id,
                    level_id: Number(this.selected_level_id),
                }
                this.is_loading = true;
                this.saveLevelLead(params)
                .then(()=>{
                    this.loadLevels()
                    .then(()=>{
                        this.setLeadUserID();
                        this.loadLevelUsers(this.selected_level_id)
                        .then(()=>{
                            this.is_loading = false;
                        })
                    })

                })
            }
        },
        clearSelectedLevel(){
            this.$emit('level_id', null);
            this.$nextTick(()=>{
                this.initTable();
            })
        },
        initTable(){
            this.is_loading = true;
            this.setLeadUserID();
            if(this.selected_level_id == null){
                this.loadLevelUsers(0)
                .then(()=>{
                    this.ui.columns = this.all_users_columns;
                    this.is_loading = false;
                    this.initTableFilter();
                })
            }
            else if(this.selected_level_id != undefined){
                this.loadLevelUsers(this.selected_level_id)
                .then(()=>{
                    this.ui.columns = this.level_users_columns;
                    this.is_loading = false;
                    this.initTableFilter();
                })
            }
        },
        initTableFilter(){
            setTimeout(()=>{
                //eslint-disable-next-line
                function isEq(a,b){
                    if(a == null){
                        return false;
                    }
                    a = a.toString().toLowerCase();
                    return a.indexOf(b) !== -1;
                }
                //eslint-disable-next-line
                if(!$$("clientUsersTable")){
                    // table not found
                    return;
                }
                //eslint-disable-next-line
                $$("clientUsersTable").filterByAll=function(){
                        //get filter values
                        if(this.getFilter("index") == null){
                            return false;
                        }
                        else{
                            var text = this.getFilter("index").value.toString().toLowerCase();
                            //unfilter for empty search text
                            if (!text) return this.filter();

                            //filter using OR logic
                            this.filter(function(obj){

                                if (isEq(obj.name, text)){
                                    return true;
                                }
                                if (isEq(obj.level_name, text)) {
                                    return true;
                                }
                                return false;
                            });
                        }
                    }
            }, 100)
        }
    },
    mounted(){
        this.initTable();
    },

}
</script>

<style>
.text-selectable{
    cursor: pointer;
}
.text-selectable:hover{
    text-decoration: underline;
}
</style>
